import axios from 'axios';
import {APIURL} from '../consts/apiUrl';
import {useNotification} from './useNotification';
import {queryFormat} from '../Helpers/stringFormat';
import {Language} from '../context/LanguageContext';
import Swal from 'sweetalert2';

export const useUser = () => {
  const {notificationHandler} = useNotification();
  const {newObj, language} = Language();
  const getUserList = async (tokens_session, payload) => {
    const response = await axios.post(APIURL.user_list, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${tokens_session}`,
      },
    });
    notificationHandler(response.data.status, response.data.message, false);
    return response;
  };

  const createUser = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      for (const item in payload) {
        if (item !== 'avatarPreview')
          if (payload[item] && !Array.isArray(payload[item]))
            formData.append(item, payload[item]);
          else if (item === 'group')
            formData.append('group', payload[item].join(','));
          else if (item === 'status') formData.append('status', payload[item]);
      }
      const response = await axios.post(APIURL.user_create, formData, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updateUser = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      for (const item in payload) {
        if (item !== 'avatarPreview')
          if (payload[item] && !Array.isArray(payload[item]))
            formData.append(item, payload[item]);
          else if (item === 'group')
            formData.append('group', payload[item].join(','));
          else if (item === 'status') formData.append('status', payload[item]);
      }
      const response = await axios.post(APIURL.user_update, formData, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getUserGroupList = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.user_group_list, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message, false);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const createUserGroup = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.user_group_create, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updateUserGroup = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.user_group_update, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const searchPIC = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.pic_search, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getPICList = async (tokens_session, payload) => {
    const response = await axios.get(
      APIURL.pic_list + '?' + queryFormat(payload),
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      }
    );
    notificationHandler(response.data.status, response.data.message, false);
    return response;
  };

  const createPIC = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      formData.append('language', payload.language);
      formData.append('fullname', payload.fullname);
      formData.append('email', payload.email);
      formData.append('phone', payload.phone);
      formData.append('jawatan', payload.jawatan);
      formData.append('pk_code', payload.pk_code);
      formData.append('nama_kawasan', payload.nama_kawasan);
      formData.append('avatar', payload.avatar);

      const response = await axios.post(APIURL.pic_create, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updatePIC = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      formData.append('id', payload.id);
      formData.append('language', payload.language);
      formData.append('fullname', payload.fullname);
      formData.append('email', payload.email);
      formData.append('phone', payload.phone);
      formData.append('jawatan', payload.jawatan);
      formData.append('pk_code', payload.pk_code);
      formData.append('nama_kawasan', payload.nama_kawasan);
      if (payload.avatar) formData.append('avatar', payload.avatar);
      const response = await axios.post(APIURL.pic_update, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getDocumentationList = async (tokens_session, payload) => {
    const reponse = await axios.post(APIURL.dokumentasi_list, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${tokens_session}`,
      },
    });
    return reponse;
  };

  const createDocumentation = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.dokumentasi_create, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updateDocumentation = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.dokumentasi_update, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      notificationHandler(response.data.status, response.data.message);
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const deleteDocumentation = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.dokumentasi_delete, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
        responseType: 'arraybuffer',
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };
  const downloadDocumentation = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      formData.append('path', payload.path);
      formData.append('filename', payload.filename);
      const response = await axios.post(APIURL.dokumentasi_download, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getProgramKerjaList = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.program_kerja_list, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };
  const createProgramKerja = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.program_kerja_create, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };
  const updateProgramKerja = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.program_kerja_update, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const uploadSyorSawit = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.syor_sawit_upload, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
    }
  };

  const uploadSyorGetah = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.syor_getah_upload, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
    }
  };

  const getSyorList = async (tokens_session, payload) => {
    try {
      const response = await axios.get(
        APIURL.syor_list + '?' + queryFormat(payload),
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updateSyor = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.syor_update, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const deleteSyor = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.syor_delete, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const downloadSyor = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.syor_download, payload, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
          'Content-Type': 'multipart/form-data',
        },
        responseType: 'arraybuffer',
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const uploadAtdPhSawit = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_ph_sawit_upload, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
    }
  };

  const uploadAtdPhGetah = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_ph_getah_upload, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      // notificationHandler(error.response.data.status, error.response.data.data);
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
    }
  };

  const uploadAtdNpkSawit = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_npk_sawit_upload, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(error.response.data.status, error.response.data.data);
    }
  };

  const uploadAtdNpkGetah = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_npk_getah_upload, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(error.response.data.status, error.response.data.data);
    }
  };

  const getAtdList = async (tokens_session, payload) => {
    try {
      const response = await axios.get(
        APIURL.atd_list + '?' + queryFormat(payload),
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updateAtd = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_update, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const deleteAtd = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_delete, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const downloadAtd = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.atd_download, payload, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
          'Content-Type': 'multipart/form-data',
        },
        responseType: 'arraybuffer',
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getPPPLSList = async (tokens_session, payload) => {
    try {
      const response = await axios.get(
        APIURL.pppls_list + '?' + queryFormat(payload),
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updatePPPLS = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.pppls_update, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const deletePPPLS = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.pppls_delete, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };
  const downloadPPPLS = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.pppls_download, payload, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
          'Content-Type': 'multipart/form-data',
        },
        responseType: 'arraybuffer',
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getPPPLSAllKawasan = async (tokens_session, payload) => {
    try {
      const response = await axios.get(
        APIURL.pppls_get_all_kawasan + '?' + queryFormat(payload),
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getPPPLSAuthorization = async (tokens_session) => {
    try {
      const response = await axios.get(APIURL.pppls_get_authorization, {
        headers: {
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getApplicationUnauthorizationList = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      formData.append('q', payload.q);
      const response = await axios.post(
        APIURL.app_auth_unauthorization_list,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getApplicationAuthorizationList = async (tokens_session, payload) => {
    try {
      const formData = new FormData();
      formData.append('q', payload.q);
      const response = await axios.post(
        APIURL.app_auth_authorization_list,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const createApplicationAuthorization = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.app_auth_create, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const getPesertaDanLotList = async (tokens_session, payload) => {
    try {
      const response = await axios.get(
        APIURL.peserta_dan_lost_list + '?' + queryFormat(payload),
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const deletePesertaDanLot = async (tokens_session, payload) => {
    try {
      const response = await axios.post(
        APIURL.peserta_dan_lost_delete,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const downloadPesertaDanLot = async (tokens_session, payload) => {
    try {
      const response = await axios.post(
        APIURL.peserta_dan_lot_download,
        payload,
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'arraybuffer',
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const uploadKewanganPnP = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.upload_kewangan_pnp, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
      return error.response;
    }
  };

  const uploadKewanganJV = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.upload_kewangan_jv, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
      return error.response;
    }
  };

  const uploadKewanganFB = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.upload_kewangan_fb, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: newObj.UploadFailWord[language],
        text: newObj.UploadFailMessageWord[language],
      });
      return error.response;
    }
  };

  const getKewanganList = async (tokens_session, payload) => {
    try {
      const response = await axios.get(
        APIURL.kewangan_list + '?' + queryFormat(payload),
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const updateKewangan = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.kewangan_update, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const deleteKewangan = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.kewangan_delete, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  const downloadKewangan = async (tokens_session, payload) => {
    try {
      const response = await axios.post(APIURL.kewangan_download, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${tokens_session}`,
        },
        responseType: 'arraybuffer',
      });
      return response;
    } catch (error) {
      notificationHandler(
        error.response.data.status,
        error.response.data.message
      );
    }
  };

  return {
    getUserList,
    createUser,
    updateUser,
    getUserGroupList,
    createUserGroup,
    updateUserGroup,
    searchPIC,
    getPICList,
    createPIC,
    updatePIC,
    getDocumentationList,
    createDocumentation,
    updateDocumentation,
    deleteDocumentation,
    downloadDocumentation,
    getProgramKerjaList,
    createProgramKerja,
    updateProgramKerja,
    uploadSyorSawit,
    uploadSyorGetah,
    uploadAtdPhSawit,
    uploadAtdPhGetah,
    uploadAtdNpkSawit,
    uploadAtdNpkGetah,
    getSyorList,
    updateSyor,
    deleteSyor,
    downloadSyor,
    getAtdList,
    updateAtd,
    deleteAtd,
    downloadAtd,
    getPPPLSList,
    updatePPPLS,
    deletePPPLS,
    downloadPPPLS,
    getPPPLSAllKawasan,
    getPPPLSAuthorization,
    getApplicationUnauthorizationList,
    getApplicationAuthorizationList,
    createApplicationAuthorization,
    getPesertaDanLotList,
    deletePesertaDanLot,
    downloadPesertaDanLot,
    uploadKewanganPnP,
    uploadKewanganJV,
    uploadKewanganFB,
    getKewanganList,
    updateKewangan,
    deleteKewangan,
    downloadKewangan,
  };
};
